module.exports = __webpack_public_path__ + "img/icon_validationfailed.31056fb4.png";